/* import __COLOCATED_TEMPLATE__ from './section-group.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    title: string;
  };
  Blocks: {
    icon: [];
    default: [];
  };
}

const SectionGroup = templateOnlyComponent<Signature>();
export default SectionGroup;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::SectionGroup': typeof SectionGroup;
    'workflows/graph-editor/node-items/steps/fin/section-group': typeof SectionGroup;
  }
}
